const styles = {
  button: {
    borderRadius: '4px',
  },
  saveButton: {
    border: '1px solid #F89137',
    '&:disabled': {
      border: '1px solid rgba(0, 0, 0, 0.12)',
    },
  },
  cancelButton: {
    color: '#212322',
    border: '1px solid rgba(0,0,0,0.12)',
    boxSizing: 'border-box',
    marginRight: '16px',
  },
};

export default styles;
